export const UPLOAD_DATES = [
  'monday',
  'tuesday',
  'wednesday',
  'thursday',
  'friday',
  'saturday',
  'sunday',
];

export const SERIES_CATEGORY = [
  'POEM',
  'NOVEL',
  'INTERVIEW',
  'ESSAY',
  'CRITIQUE',
  'ETC',
];
